/* Generated by scripts/generate.ts from src/locales. Do not edit by hand. */
import type { NamespaceSchema } from "../catalogue";

export interface EarningsHubCopy {
  title: string;
  subtitle: string;
  sectionUndated: string;
  amountProjected: string;
  amountNet: string;
  decision: {
    line: (args: { decision: string | number }) => string;
    undecided: string;
    badge: (args: { decision: string | number }) => string;
    badgeUndecided: string;
  };
  actionChoose: string;
  actionChange: string;
  bankAccountMissing: string;
  actionAddBankAccount: string;
  emptyTitle: string;
  emptyBody: string;
  errorTitle: string;
  errorBody: string;
  errorRetry: string;
  capacityLabel: (args: { capacity: string | number }) => string;
}

export const earningsHubSchema: NamespaceSchema = {
  namespace: "earnings-hub",
  keys: {
    "title": [],
    "subtitle": [],
    "sectionUndated": [],
    "amountProjected": [],
    "amountNet": [],
    "decision.line": ["decision"],
    "decision.undecided": [],
    "decision.badge": ["decision"],
    "decision.badgeUndecided": [],
    "actionChoose": [],
    "actionChange": [],
    "bankAccountMissing": [],
    "actionAddBankAccount": [],
    "emptyTitle": [],
    "emptyBody": [],
    "errorTitle": [],
    "errorBody": [],
    "errorRetry": [],
    "capacityLabel": ["capacity"],
  },
};
